import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input() disableHoverForSmallText = true;
  @Input() toolTipControl: NgbTooltip;

  @Input() hoverClass = 'pointer-cursor';

  @Input() showOnHover = false;

  constructor(
    public readonly renderer: Renderer2,
    private readonly hostElement: ElementRef<HTMLElement>,
    private readonly ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this.ngZone.runOutsideAngular(() => {
      globalThis.addEventListener('scroll', this.closeTooltipOnScroll, {
        passive: true,
      });
    });
  }

  ngOnDestroy(): void {
    globalThis.removeEventListener('scroll', this.closeTooltipOnScroll);
  }

  @HostListener('mouseenter') onMouseEnter(): void {
    if (this.hostElement?.nativeElement) {
      const element = this.hostElement.nativeElement;

      const isTruncated = this.hasTruncated();

      if (isTruncated) {
        this.renderer.addClass(element, this.hoverClass);
      }

      if (
        this.showOnHover &&
        this.toolTipControl &&
        typeof this.toolTipControl.open === 'function'
      ) {
        if (!this.disableHoverForSmallText || isTruncated) {
          this.toolTipControl.open();
        }
      }
    }
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    if (this.hostElement?.nativeElement) {
      const element = this.hostElement.nativeElement;
      this.renderer.removeClass(element, this.hoverClass);

      if (
        this.showOnHover &&
        this.toolTipControl &&
        typeof this.toolTipControl.close === 'function'
      ) {
        this.toolTipControl.close();
      }
    }
  }

  @HostListener('click', ['$event']) onClick(event: Event): void {
    if (this.showOnHover) return;

    if (this.disableHoverForSmallText && !this.hasTruncated()) {
      return;
    }

    if (
      this.toolTipControl &&
      typeof this.toolTipControl.toggle === 'function'
    ) {
      this.toolTipControl.toggle();
    }

    event.preventDefault();
    event.stopPropagation();
  }

  public hasTruncated(): boolean {
    const element = this.hostElement.nativeElement;

    return (
      element.clientHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth
    );
  }

  private readonly closeTooltipOnScroll = (): void => {
    if (
      this.toolTipControl instanceof NgbTooltip &&
      this.toolTipControl.isOpen()
    ) {
      this.ngZone.run(() => this.toolTipControl.close());
    }
  };
}
